import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useGetReceiptDetails() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const getReceiptDetails = useCallback(() => {
    return new Promise((resolve, reject) => {
      fetchWrapper({
        endpoint_url: "transaction/getReceiptDetails",
        onSuccess: (fetch_output) => {
          if (fetch_output.status) {
            resolve(fetch_output.data);
          } else {
            showMessage({ type: "warning", message: fetch_output.error });
            reject(fetch_output.error);
          }
        },
        onFetchError: () => {
          showMessage({ apiType: "fetch", message: "Get Receipt Details" });
          reject("Fetch error");
        },
        onResponseError: () => {
          showMessage({ apiType: "response", message: "Get Receipt Details" });
          reject("Response error");
        },
      });
    });
  }, [fetchWrapper]);

  return { getReceiptDetails };
}

export default useGetReceiptDetails;
